import { z } from "zod";

export const addPrintImageConfigurationSchema = z.object({
	imageFileName: z.string(),
	isExternal: z.boolean(),
	isSmartScaling: z.boolean(),
	dotFileName: z.string().nullable(),
	shippingFileName: z.string().nullable(),
	lpnFileName: z.string().nullable(),
});
